import React from 'react'

// we need a context to pass wizard props to sub-routes in react router 4
const WizardContext = React.createContext({})

export default WizardContext
